import { t } from 'utils/localize';

export default function v_max_length(value: string, args: { max: number; message?: string }) {
  return {
    message: args.message || t('Too many characters'),
    validate: () => {
      return value.length <= args.max;
    },
  };
}
